<template lang="pug">
.leftNav
  el-input(v-model="filterTextSys", size="small", placeholder="输入关键字进行过滤", clearable)
  el-tree.treeList.filter-tree(
    ref="projectTree",
    node-key="nodeId",
    :data="projectRoleData",
    :props="defaultRoleProps",
    :filter-node-method="filterNode",
    show-checkbox,
    @check="checkNodeChange",
    v-slot="{ node, data }"
  )
    node-icon(:node="node", type="PrjRole") {{ data.roleName }}
</template>

<script>
import { mapState } from "vuex";
import flowService from "@/CommonDP/service/flow-service";
import NodeIcon from "./NodeIcon.vue";

export default {
  components: { NodeIcon },
  props: {
    // 选中的人员组件
    userList: { type: Array, default: () => [] }
  },
  data() {
    return {
      projectRoleData: [], // 项目角色列表
      filterTextSys: "",
      defaultRoleProps: {
        children: "children",
        label: "roleName"
      },
      nowSelect: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    }),
    defaultCheckedKeys() {
      return this.nowSelect?.map(({ nodeId }) => nodeId) || [];
    }
  },
  watch: {
    filterTextSys(val) {
      this.$refs.projectTree.filter(val);
    },
    userList: {
      immediate: true,
      async handler(val) {
        this.nowSelect = val;
        this.$refs.projectTree?.setCheckedKeys(this.defaultCheckedKeys);
      }
    }
  },
  mounted() {
    this.getRoleListFlow();
  },
  methods: {
    // 获取系统角色列表
    async getRoleListFlow() {
      const res = await flowService.queryRoleListFlow(this.enterpriseId);
      this.projectRoleData = res.data.map(e => { return { ...e, nodeId: e.roleID }; }) || [];
      if (this.nowSelect && this.nowSelect.length > 0) {
        await this.$nextTick();
        this.$refs.projectTree?.setCheckedKeys(this.defaultCheckedKeys);
      }
    },
    // 系统角色树形结构选择器
    checkNodeChange(data, currentChecked) {
      this.nowSelect = this.$refs.projectTree.getCheckedNodes();
      this.emitList();
    },
    // 给父级抛出选中的人员
    emitList() {
      const list = this.nowSelect.map((e) => {
        return {
          ...e,
          id: e.roleID,
          userId: e.roleID,
          name: e.roleName,
          selectName: e.roleName,
          type: 3
        };
      });
      this.$emit("updateRight", "PrjRole", list);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.roleName.indexOf(value) !== -1;
    }
  }
};
</script>

<style>
</style>
